import { useEffect } from 'react';

import useBodyScrollBlock from './useBodyScrollBlock';

export const useScrollBlocker = (isBlocking = false) => {
  const { identifier, blocksBodyScroll } = useBodyScrollBlock();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return () => null;
    }

    blocksBodyScroll(isBlocking);

    return () => {
      blocksBodyScroll(false);
    };
  }, [isBlocking, blocksBodyScroll]);

  return { identifier };
};

/** @deprecated Use useBodyScrollBlock instead */
export default useScrollBlocker;
